import React                   from 'react';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

// export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
// export const DAEMON = '@@saga-injector/daemon';
// export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const STAND_STATUS: (null|React.JSX.Element)[] = [
  null,
  <FormattedMessageWrapper id="En attente des plans" key="1" />,
  <FormattedMessageWrapper id="En attente de vérification des plans" key="2" />,
  <FormattedMessageWrapper id="En attente de confirmation des plans" key="3" />,
  <FormattedMessageWrapper id="Plans validés" key="4" />,
  <FormattedMessageWrapper id="Plans en cours de vérification" key="5" />,
];

export const STATUS_CONVERTER = {
  waiting: 1,
  // eslint-disable-next-line sort-keys
  pendingVerification: 2,
  // eslint-disable-next-line sort-keys
  pendingConfirmation: 3,
  validated: 4,
  // eslint-disable-next-line sort-keys
  beingVerified: 5,
};

export const STATUS_REVERSE_CONVERTER: (null|string)[] = [
  null,
  'waiting',
  'pendingVerification',
  'pendingConfirmation',
  'validated',
  'beingVerified',
];

export const ROLES: Record<string, string> = {
  admin: 'ROLE_ADMIN',
  agency: 'ROLE_STANDIST_AGENCY',
  coordinator_sps: 'ROLE_COORDINATOR_SPS',
  decorator: 'ROLE_STANDIST_DECORATOR',
  exhibitor: 'ROLE_STANDIST_EXHIBITOR',
  organizer: 'ROLE_ORGANIZER',
  support_astech: 'ROLE_SUPPORT_ASTECH',
};

export const ROLES_CONVERTER: Record<string, React.JSX.Element> = {
  ROLE_ADMIN: <FormattedMessageWrapper id="Administrateur" />,
  ROLE_COORDINATOR_SPS: <FormattedMessageWrapper id="Coordonnateur SPS" />,
  ROLE_ORGANIZER: <FormattedMessageWrapper id="Organisateur" />,
  ROLE_STANDIST_AGENCY: <FormattedMessageWrapper id="Agence" />,
  ROLE_STANDIST_DECORATOR: <FormattedMessageWrapper id="Décorateur" />,
  ROLE_STANDIST_EXHIBITOR: <FormattedMessageWrapper id="Exposant" />,
  ROLE_SUPER_ADMIN: <FormattedMessageWrapper id="Super Administrateur" />,
  ROLE_SUPPORT_ASTECH: <FormattedMessageWrapper id="Gestionnaire Salon" />,
};

export const REPORT_STATUS = {
  IN_PROGRESS: 1,
  // eslint-disable-next-line sort-keys
  CLOSED: 2,
};

export const TIME = {
  defaultDateTimeFormat: 'DD/MM/YYYY HH[h]mm',
  utcDateTimeFormat: 'YYYY-MM-DDTHH:mm',
};
